import React from 'react';
import TabNavigation from './TabNavigation';

const AppLayout = ({ children }) => (
    <div style={{
        minHeight: '100vh',
        backgroundColor: '#F5F5F7',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        color: '#1D1D1F',
    }}>
        <TabNavigation />
        <main style={{ padding: 'clamp(1rem, 2vw, 2rem)' }}>
            {children}
        </main>
    </div>
);

export default AppLayout;
